import Image from "components/Image"
import TitleBanner from "components/DynamicComponent/atoms/TitleBanner"
import richText from "utilities/richText"

export default function IntroWithBannerAndImage({ blok }) {
  return (
    <>
      <TitleBanner blok={blok} />
      <section className="bg-gray-light px-8">
        <div className="max-w-screen-xl mx-auto flex flex-col-reverse md:flex-row">
          <div className="basis-3/5 py-6 xl:py-8 prose-p:pb-2 pb-8 md:pb-0 md:pr-12 -mt-24 md:-mt-0">
            {richText(blok.content)}
          </div>
          <div className="basis-2/5">
            <Image
              src={blok.image.filename}
              alt={blok.image.alt}
              placeholder={blok.image?.blurDataURL ? "blur" : "empty"}
              blurDataURL={blok.image?.blurDataURL}
              width={520}
              height={485}
              className="relative mx-auto w-full md:w-auto md:scale-110 -top-24 md:-top-12"
            />
          </div>
        </div>
      </section>
    </>
  )
}
